export default __webpack_public_path__ + "static/media/sport_badges_background.69a5e8bb.png";